import { IconButton } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import * as S from "./styles";

const QuantitySelector = ({ 
  count, 
  handleIncrement, 
  handleDecrement, 
  AllowedZero = false,
  maxCount = 9,
  minCount 
}) => {
  const actualMinCount = minCount !== undefined ? minCount : (AllowedZero ? 0 : 1);

  return (
    <S.Container>
      <IconButton
        size="small"
        onClick={handleDecrement}
        disabled={count <= actualMinCount}
      >
        <RemoveIcon />
      </IconButton>
      <S.CountDisplay>{count}</S.CountDisplay>
      <IconButton
        size="small"
        onClick={handleIncrement}
        disabled={count >= maxCount}
      >
        <AddIcon />
      </IconButton>
    </S.Container>
  );
};

export default QuantitySelector;